import * as React from 'react';
import { View } from 'react-native';

export default function CrashingComponent() {
  return <View>''</View>;
}
